import React, { useState, useEffect } from 'react'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ContactPersonSectionsWidget from '../../../Components/shared/ContactPersonSectionsWidget'
import { fetchAllContactPersonsSchool, getContactPersons } from '../../../reducers/ContactPersonsReducer/actions'
import { getSchools } from '../../../reducers/SchoolsReducer'
import { getUser } from '../../../reducers/UserReducer'
import { getSectionsWithContactPerson } from '../../../utils/api/school'
import ContactPersonTable from './ContactPersonTable'
import { formatOldSection, isNewSection, schoolSectionToString } from '../../../utils/entitiesFormaters/SchoolSection'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    getUser: getUser(state.getUser),
    getSchools: getSchools(state.getSchools),
    getContactPersons: getContactPersons(state)
  }
}

const mapDispatchToProps = dispatch => ({
  fetchAllContactPersonsSchool: bindActionCreators(fetchAllContactPersonsSchool, dispatch)
})

const ContactPersonsSchool = props => {
  const { t, getUser, getSchools, getContactPersons, fetchAllContactPersonsSchool } = props

  const additionalActions = [
    {
      iconName: 'graduation-cap',
      type: 'primary',
      title: t('Display sections for this user'),
      onClick: u => setSelectedContactPersonSchoolSection(u)
    }
  ]

  const [contactPersons, setContactPersons] = useState([])
  const [optionsSelect, setOptionSelect] = useState([])
  const [selectValue, setSelectValue] = useState(null)
  const [loading, setLoading] = useState(true)
  const [selectedContactPersonSchoolSection, setSelectedContactPersonSchoolSection] = useState(null)
  const [school, setSchool] = useState(null)

  useEffect(() => {
    if (getSchools.length > 0 && typeof fetchAllContactPersonsSchool === 'function') {
      setLoading(true)
      fetchAllContactPersonsSchool(getSchools[0].id, getUser)
      setSchool(getSchools[0].id)

      getSectionsWithContactPerson(getSchools[0], getUser)
        .then(data => {
          setOptionSelect(data[getSchools[0].id].map(s => {
            return { ...s, name: isNewSection(s) ? schoolSectionToString(s) : formatOldSection(s) }
          }))
        })
    }
  }, [getSchools[0]?.id, fetchAllContactPersonsSchool, getUser])

  useEffect(() => {
    if (getContactPersons) {
      try {
        setContactPersons(getContactPersons)
        setLoading(false)
      } catch (err) {
        console.error(err)
      }
    }
  }, [getContactPersons])

  const handleChangeSelectSchoolSection = value => {
    if (value === 'all') {
      setContactPersons(getContactPersons)
    } else {
      setContactPersons(getContactPersons.filter(cp => {
        for (const section of cp.contactPersonSections) {
          if (section.id === value) {
            return cp
          }
        }
      }))
    }

    setSelectValue(value)
  }

  return (
    <>
      <ContactPersonTable
        contactPersons={contactPersons}
        loading={loading}
        additionalActions={additionalActions}
        onChangeSelect={handleChangeSelectSchoolSection}
        allOptionText={t('All school sections')}
        selectValue={selectValue}
        optionsSelect={optionsSelect}
      />
      <ContactPersonSectionsWidget
        user={selectedContactPersonSchoolSection}
        school={school}
        onClose={() => setSelectedContactPersonSchoolSection(null)}
      />
    </>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactPersonsSchool)
